import React from "react";

import styles from "../CouponForm.module.scss";

const CouponFormFieldLabel = ({ children, required = false, optional = false }) => (
  <label className={styles.fieldLabel}>
    {children}
    {required && <span className={styles.required}>*</span>}
    {optional && <span className={styles.optional}> (Optional)</span>}
  </label>
);

export default CouponFormFieldLabel;
